// extracted by mini-css-extract-plugin
export default {"canvas":"Xl6yX","attributes":"fLJf4"};